import React from 'react';
import { CampaignBanner } from '@components/SectionBlocks/blocks/Campaign';
import { CampaignBlockType } from '@appTypes/campaignBlockType';
import * as S from './CampaignBlock.styles';

interface CampaignBlockSerializerProps {
  value: CampaignBlockType;
}

export const CampaignBlock = ({ value }: CampaignBlockSerializerProps) => (
  <CampaignBanner campaign={{ ...value, variant: value.variant || 'medium' }} />
);

export const CampaignBlockSerializer =
  () =>
  ({ value }: CampaignBlockSerializerProps) => (
    <S.StyledArticleBlockContentGridCol className="campaignBlock">
      <CampaignBlock value={value} />
    </S.StyledArticleBlockContentGridCol>
  );
